import React from "react";

import { CommonProps } from "@utils/interface";
import { styled } from "@acko-tech/building-blocks.ui.common";

const Container = styled.div`
  > * {
    padding: 1rem 0px;
    border-bottom: 1px solid #e0e0e8;
  }
  > :first-child {
    padding: 0px 0px 1rem;
  }
  > :last-child {
    padding: 1rem 0px 0px;
    border-bottom: none;
  }
  > :only-child {
    padding: 0px;
  }
`;

interface IAddonUpgradesContainer extends CommonProps {}

const AddonsContainer = ({ children }: IAddonUpgradesContainer) => {
  return <Container>{children}</Container>;
};

export default AddonsContainer;
